/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { GroupContractType } from './GroupContractType';
import {
    GroupContractTypeFromJSON,
    GroupContractTypeFromJSONTyped,
    GroupContractTypeToJSON,
    GroupContractTypeToJSONTyped,
} from './GroupContractType';
import type { GroupContractBrokerDto } from './GroupContractBrokerDto';
import {
    GroupContractBrokerDtoFromJSON,
    GroupContractBrokerDtoFromJSONTyped,
    GroupContractBrokerDtoToJSON,
    GroupContractBrokerDtoToJSONTyped,
} from './GroupContractBrokerDto';
import type { GroupContractTunnelDto } from './GroupContractTunnelDto';
import {
    GroupContractTunnelDtoFromJSON,
    GroupContractTunnelDtoFromJSONTyped,
    GroupContractTunnelDtoToJSON,
    GroupContractTunnelDtoToJSONTyped,
} from './GroupContractTunnelDto';
import type { GroupContractSubscriberDto } from './GroupContractSubscriberDto';
import {
    GroupContractSubscriberDtoFromJSON,
    GroupContractSubscriberDtoFromJSONTyped,
    GroupContractSubscriberDtoToJSON,
    GroupContractSubscriberDtoToJSONTyped,
} from './GroupContractSubscriberDto';

/**
 * 
 * @export
 * @interface GroupContractDto
 */
export interface GroupContractDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    id: string;
    /**
     * Identifier of the contract. Null for drafts without any tunnel.
     * @type {string}
     * @memberof GroupContractDto
     */
    contractIdentifier?: string | null;
    /**
     * Localized status label (FR libellé), for display only.
     * @type {string}
     * @memberof GroupContractDto
     */
    status: string;
    /**
     * Stable status code (Codes.StatutsContrats — "B" draft, "EC" active...), for front logic.
     * @type {string}
     * @memberof GroupContractDto
     */
    statusCode?: string | null;
    /**
     * Main due date pre-formatted in French (e.g. "01 janvier"). Null if not set.
     * @type {string}
     * @memberof GroupContractDto
     */
    mainDueDate?: string | null;
    /**
     * Raw day of the main due date.
     * @type {number}
     * @memberof GroupContractDto
     */
    mainDueDateDay?: number | null;
    /**
     * Raw month of the main due date.
     * @type {number}
     * @memberof GroupContractDto
     */
    mainDueDateMonth?: number | null;
    /**
     * Owner / propriétaire (legal entity designation).
     * @type {string}
     * @memberof GroupContractDto
     */
    owner?: string | null;
    /**
     * Subscriber name (no fallback on owner). Null if not set.
     * @type {string}
     * @memberof GroupContractDto
     */
    subscriberName?: string | null;
    /**
     * True if contract type is CADRE (kept for API backward compatibility)
     * @type {boolean}
     * @memberof GroupContractDto
     */
    isMaster: boolean;
    /**
     * Portée du contrat — PersonneMorale = contrat de cabinet (vendu par le cabinet créateur), Plateforme = contrat de la plateforme (créé par la PM principale ou le back-office, vendu par les courtiers habilités). Le back accepte encore l'ancien nom "Organisation" en entrée mais ne l'écrit plus.
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    scope?: GroupContractDtoScopeEnum;
    /**
     * Products covered by the contract (derived from active tunnels, deduplicated).
     * @type {Array<IdLabel>}
     * @memberof GroupContractDto
     */
    products?: Array<IdLabel>;
    /**
     * 
     * @type {GroupContractType}
     * @memberof GroupContractDto
     */
    type?: GroupContractType;
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    plateformeId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    plateformeName?: string;
    /**
     * 
     * @type {GroupContractSubscriberDto}
     * @memberof GroupContractDto
     */
    subscriber?: GroupContractSubscriberDto;
    /**
     * True if the contract was created by a broker (CreateurCourtierId set)
     * @type {boolean}
     * @memberof GroupContractDto
     */
    isBrokerOwned?: boolean;
    /**
     * ID of the broker who created the contract (null = admin contract)
     * @type {string}
     * @memberof GroupContractDto
     */
    creatorBrokerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    creationTime: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    lastModificationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupContractDto
     */
    quotesCount: number;
    /**
     * 
     * @type {number}
     * @memberof GroupContractDto
     */
    activeContractsCount: number;
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    noticePeriodDuration: string;
    /**
     * Raw notice period value (count of units).
     * @type {number}
     * @memberof GroupContractDto
     */
    noticeDurationValue?: number | null;
    /**
     * Notice period unit (UnitesPreavis enum, 1=Days, 2=Weeks, 3=Months, 4=Years).
     * @type {number}
     * @memberof GroupContractDto
     */
    noticeDurationUnit?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    partnerIdentifier: string;
    /**
     * Contrat CADRE : chaque aliment règle son propre prélèvement, plutôt que le souscripteur pour l'ensemble. Exposé par le back sur le détail du contrat de groupe, et lu par l'écran de détail pour afficher qui est quittancé.
     * @type {boolean}
     * @memberof GroupContractDto
     */
    paymentByAliments?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GroupContractDto
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupContractDto
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GroupContractDto
     */
    periodicity?: string;
    /**
     * Id of the periodicity (ContractPeriodicity referential).
     * @type {string}
     * @memberof GroupContractDto
     */
    periodicityId?: string | null;
    /**
     * Distinct insurer names (lead insurer + co-insurers) resolved from the guarantee exercices of the active tunnels. For header display only.
     * @type {Array<string>}
     * @memberof GroupContractDto
     */
    insurers?: Array<string>;
    /**
     * 
     * @type {Array<GroupContractTunnelDto>}
     * @memberof GroupContractDto
     */
    tunnels: Array<GroupContractTunnelDto>;
    /**
     * 
     * @type {Array<GroupContractBrokerDto>}
     * @memberof GroupContractDto
     */
    brokers: Array<GroupContractBrokerDto>;
    /**
     * True when the contract is locked (at least one mandate signed OR contract finalized).
     * When locked, every mutation (special conditions, subscriber, products, brokers) is rejected.
     * 
     * @type {boolean}
     * @memberof GroupContractDto
     */
    isLocked?: boolean;
}


/**
 * @export
 */
export const GroupContractDtoScopeEnum = {
    PersonneMorale: 'PersonneMorale',
    Plateforme: 'Plateforme'
} as const;
export type GroupContractDtoScopeEnum = typeof GroupContractDtoScopeEnum[keyof typeof GroupContractDtoScopeEnum];


/**
 * Check if a given object implements the GroupContractDto interface.
 */
export function instanceOfGroupContractDto(value: object): value is GroupContractDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isMaster' in value) || value['isMaster'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    if (!('activeContractsCount' in value) || value['activeContractsCount'] === undefined) return false;
    if (!('noticePeriodDuration' in value) || value['noticePeriodDuration'] === undefined) return false;
    if (!('partnerIdentifier' in value) || value['partnerIdentifier'] === undefined) return false;
    if (!('tunnels' in value) || value['tunnels'] === undefined) return false;
    if (!('brokers' in value) || value['brokers'] === undefined) return false;
    return true;
}

export function GroupContractDtoFromJSON(json: any): GroupContractDto {
    return GroupContractDtoFromJSONTyped(json, false);
}

export function GroupContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contractIdentifier': json['contractIdentifier'] == null ? undefined : json['contractIdentifier'],
        'status': json['status'],
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'mainDueDate': json['mainDueDate'] == null ? undefined : json['mainDueDate'],
        'mainDueDateDay': json['mainDueDateDay'] == null ? undefined : json['mainDueDateDay'],
        'mainDueDateMonth': json['mainDueDateMonth'] == null ? undefined : json['mainDueDateMonth'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'subscriberName': json['subscriberName'] == null ? undefined : json['subscriberName'],
        'isMaster': json['isMaster'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(IdLabelFromJSON)),
        'type': json['type'] == null ? undefined : GroupContractTypeFromJSON(json['type']),
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'plateformeName': json['plateformeName'] == null ? undefined : json['plateformeName'],
        'subscriber': json['subscriber'] == null ? undefined : GroupContractSubscriberDtoFromJSON(json['subscriber']),
        'isBrokerOwned': json['isBrokerOwned'] == null ? undefined : json['isBrokerOwned'],
        'creatorBrokerId': json['creatorBrokerId'] == null ? undefined : json['creatorBrokerId'],
        'creationTime': json['creationTime'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'quotesCount': json['quotesCount'],
        'activeContractsCount': json['activeContractsCount'],
        'noticePeriodDuration': json['noticePeriodDuration'],
        'noticeDurationValue': json['noticeDurationValue'] == null ? undefined : json['noticeDurationValue'],
        'noticeDurationUnit': json['noticeDurationUnit'] == null ? undefined : json['noticeDurationUnit'],
        'partnerIdentifier': json['partnerIdentifier'],
        'paymentByAliments': json['paymentByAliments'] == null ? undefined : json['paymentByAliments'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'periodicity': json['periodicity'] == null ? undefined : json['periodicity'],
        'periodicityId': json['periodicityId'] == null ? undefined : json['periodicityId'],
        'insurers': json['insurers'] == null ? undefined : json['insurers'],
        'tunnels': ((json['tunnels'] as Array<any>).map(GroupContractTunnelDtoFromJSON)),
        'brokers': ((json['brokers'] as Array<any>).map(GroupContractBrokerDtoFromJSON)),
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
    };
}

export function GroupContractDtoToJSON(json: any): GroupContractDto {
    return GroupContractDtoToJSONTyped(json, false);
}

export function GroupContractDtoToJSONTyped(value?: GroupContractDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contractIdentifier': value['contractIdentifier'],
        'status': value['status'],
        'statusCode': value['statusCode'],
        'mainDueDate': value['mainDueDate'],
        'mainDueDateDay': value['mainDueDateDay'],
        'mainDueDateMonth': value['mainDueDateMonth'],
        'owner': value['owner'],
        'subscriberName': value['subscriberName'],
        'isMaster': value['isMaster'],
        'scope': value['scope'],
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(IdLabelToJSON)),
        'type': GroupContractTypeToJSON(value['type']),
        'plateformeId': value['plateformeId'],
        'plateformeName': value['plateformeName'],
        'subscriber': GroupContractSubscriberDtoToJSON(value['subscriber']),
        'isBrokerOwned': value['isBrokerOwned'],
        'creatorBrokerId': value['creatorBrokerId'],
        'creationTime': value['creationTime'],
        'lastModificationTime': value['lastModificationTime'],
        'quotesCount': value['quotesCount'],
        'activeContractsCount': value['activeContractsCount'],
        'noticePeriodDuration': value['noticePeriodDuration'],
        'noticeDurationValue': value['noticeDurationValue'],
        'noticeDurationUnit': value['noticeDurationUnit'],
        'partnerIdentifier': value['partnerIdentifier'],
        'paymentByAliments': value['paymentByAliments'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'periodicity': value['periodicity'],
        'periodicityId': value['periodicityId'],
        'insurers': value['insurers'],
        'tunnels': ((value['tunnels'] as Array<any>).map(GroupContractTunnelDtoToJSON)),
        'brokers': ((value['brokers'] as Array<any>).map(GroupContractBrokerDtoToJSON)),
        'isLocked': value['isLocked'],
    };
}

